import { Component, OnInit } from '@angular/core';
import { AppSettingsService } from '../../../../shared/services/appsettings.service';
import { ContestWinnerModel } from '../../../galleryModule/models/contestWinner.model';
import { ContestService } from '../../../galleryModule/services/contest.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
})
export class HomeComponent implements OnInit {
  year: number;
  contestWinners: ContestWinnerModel[];

  constructor(private _contestService: ContestService) {

  }

  ngOnInit() {
    this.year = AppSettingsService.settings.lastCompletedContestYear;
    this._contestService.getWinners(this.year)
      .subscribe(
        (response: ContestWinnerModel[]) => {
          this.contestWinners = response;
        },
        error => { }
      );
  }
}
